/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { Loader, RefreshCw } from 'lucide-react';

interface UserStoryListHeaderProps {
  filteredCount: number;
  totalCount: number;
  isLoading: boolean;
  onRefresh: () => void;
}

export function UserStoryListHeader({
  filteredCount,
  totalCount,
  isLoading,
  onRefresh
}: UserStoryListHeaderProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
      <h3 style={{ margin: 0 }}>User Stories ({filteredCount} of {totalCount})</h3>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button
          onClick={onRefresh}
          disabled={isLoading}
          className="btn btn-secondary"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            padding: '8px 16px'
          }}
        >
          {isLoading ? (
            <>
              <Loader size={14} style={{ animation: 'spin 1s linear infinite' }} />
              Loading...
            </>
          ) : (
            <>
              <RefreshCw size={14} />
              Refresh
            </>
          )}
        </button>
      </div>
    </div>
  );
}

